import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=621a3a3e&"
import script from "./Home.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Home.vue?vue&type=style&index=0&id=621a3a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports